export default __webpack_public_path__ + "static/media/mlb-logo.19063c66.svg";